<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>子商户开通产品</h1>
        <p>通道商户报件</p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div><router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>AGM0202</td></tr>
          <tr><td>组织机构代码</td><td>orgCd</td><td>String（20）</td><td>是</td><td>行方提供给合作方的唯一标识</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String(15)</td><td>是</td><td>商户入驻成功后，生成的行方全局唯一的商户编号</td></tr>
          <tr><td>产品编号</td><td>proCd</td><td>String(15)</td><td>是</td><td>快捷：kj
            聚合：mcht
            刷脸：facePay
            支付宝刷脸：aliFacePay
            支付宝扫码：aliUnScanPay
            微信刷脸：facePay
            微信扫码：wxUnScanPay
          </td></tr>
          <tr><td>通道编号</td><td>chnlCd</td><td>String(15)</td><td>是</td><td>易宝通道：ybkj
            汇卡通道：hicard
            京东通道：jdpay
            微信支付：wxpay
            支付宝：alipay
            随行付：sxf
            易票联：efps
          </td></tr>
          <tr><td>费率类型</td><td>rateType</td><td>String(1)</td><td>是</td><td>0：正常费率
            1：阶梯费率
            2: 按笔
            根据需求填写商户手续费率
            0.002代表0.2%
          </td></tr>
          <tr><td>商户签约产品费率</td><td>mchtRate</td><td>String(12)</td><td>是</td><td></td></tr>
          <tr><td>结算费率类型</td><td>settleRateType</td><td>String(1)</td><td>是</td><td>0：正常费率
            1：阶梯费率
            2: 按笔
          </td></tr>
          <tr><td>商户结算费率</td><td>settleRate</td><td>String(12)</td><td>是</td><td>根据需求填写商户手续费率
            0.002代表0.2%
          </td></tr>
          <tr><td>经营类目</td><td>mchtClass</td><td>String(32)</td><td>是</td><td></td></tr>
          <tr><td>费率通道</td><td>chanelType</td><td>String(32)</td><td>是</td><td>1:常规通道；
            2: H5支付；
            3：积分支付1
            4：积分支付2
            5：条码支付
            6：刷脸支付
            7：小程序支付/App支付
            默认：1
          </td></tr>
          <tr><td>是否默认通道</td><td>isDefaultChanel</td><td>String(1)</td><td>否</td><td>0：否,1：是</td></tr>
          <tr><td>主商户号</td><td>parentMchtCd</td><td>String(32)</td><td>否</td><td class="color-red">如果是分账商户，这里必填</td></tr>
          <tr><td>明细费率</td><td>mchtRateDetail</td><td>String(1024)</td><td>否</td><td>因通道而异</td></tr>
          <tr><td>商户MCC1</td><td>mchtLevel1No</td><td>String（30）</td><td>否</td><td>因通道而异</td></tr>
          <tr><td>商户MCC2</td><td>mchtLevel2No</td><td>String（30）</td><td>否</td><td>因通道而异</td></tr>
          <tr><td>秘钥类别</td><td>agreeContent</td><td>String（30）</td><td>否</td><td>因通道而异</td></tr>
          <tr><td>结算周期</td><td>mchtSettCycle</td><td>String（30）</td><td>否</td><td>因通道而异</td></tr>
          <tr><td>商户服务代码</td><td>adddata1</td><td>String（30）</td><td>否</td><td>因通道而异</td></tr>
          <tr><td>是否自动结算</td><td>adddata2</td><td>String（1）</td><td>否</td><td>因通道而异，1：自动结算，0：不结算</td></tr>
          <tr><td>保留1</td><td>reserved1</td><td>String（30）</td><td>否</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000
            失败：返回具体的响应码</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>渠道应答码</td><td>chnlRespCode</td><td>String（12）</td><td>否</td><td></td></tr>
          <tr><td>渠道应答描述</td><td>chnlRespMsg</td><td>String（512）</td><td>否</td><td></td></tr>
          <tr><td>电子协议</td><td>agreementContent</td><td>String（204800）</td><td></td><td></td></tr>
          <tr><td>保留1</td><td>reserved1</td><td>String（30）</td><td>否</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'Zshktcp',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/zshbj', 'name': '子商户报件'},
        {'url': '/interface/xwzshbj', 'name': '小微子商户报件'},
        {'url': '/interface/tpsc', 'name': '图片上传'},
        {'url': '/interface/zshktcp', 'name': '子商户开通产品'},
        {'url': '/interface/zshcx', 'name': '子商户开通查询'},
        {'url': '/interface/zshbbcx', 'name': '子商户报备查询'},
        {'url': '/interface/zshfzxy', 'name': '子商户分账协议签署'},
        {'url': '/interface/zshpz', 'name': '子商户业务配置'},
        {'url': '/interface/zshhd', 'name': '子商户回调'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Zshktcp.vue